import React, {FC, ReactElement} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import Icon from '../icons/Icon';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        '& :first-child': {
            fill: theme.palette.text.primary,
            height: theme.typography.pxToRem(16),
            marginRight: theme.spacing(1.25)
        },
        '& :last-child': {
            fontSize: theme.typography.pxToRem(14)
        },
    },
    fullLineHeight: {
        lineHeight: 1
    },
    halfLineHeight: {
        lineHeight: 0.5,
        marginTop: theme.spacing(0.125)
    }
}));

interface IconCounterProps {
    icon: string,
    text: string | number,
    show?: boolean,
    halfLineHeight?: boolean
}

const IconText: FC<IconCounterProps> = ({icon, text, show = true, halfLineHeight = false}): ReactElement | null => {
    const classes = useStyles();

    return show
        ? (
            <Typography
                component="span"
                className={classes.root}
                color="textPrimary">
                <Icon name={icon}/>
                <Typography
                    component="span"
                    className={halfLineHeight ? classes.halfLineHeight : classes.fullLineHeight}>
                    {text}
                </Typography>
            </Typography>
        )
        : null;
};

export default IconText;
